/* =====================================================
   afk-audio — zone map (homepage "12 zones. or one.")
   Redraws the bar from one example layout to the next,
   the way the LEDs redraw when you switch presets.
   Layouts come from the section as JSON: the first is the
   zone map settings, the rest are Layout blocks.
   One zone per line: label | width in LEDs | #colour | position | from ~ to
   Zones sit on the 72 LED positions (--s = first LED,
   --n = width in LEDs); CSS turns that into geometry.
   ===================================================== */
(function () {
  'use strict';
  if (window.__afkZoneMap) return;
  window.__afkZoneMap = true;

  var PAL = ['#FF2D2D', '#FF7A00', '#FFB800', '#00E676', '#00E5FF', '#2979FF', '#B14BFF', '#FF2E9A'];
  var LEDS = 72, MAX = 12, MORPH = 900;
  var RHYTHM = [240, 240, 480, 240, 480, 720];   // gaps between simulated hits, roughly eighths at 125 bpm
  var CALM = [700, 1050, 700, 1400, 1050];        // on the filmed bar: fewer hits, so it reads calmly
  // Presets from the preset video (drumbeam alone, filmed from the front): per preset its zones as
  // [first LED, LEDs, colour, complementary colour]; the LEDs between zones stay dark on the bar.
  // VX: centre of each of the 72 LEDs in % of the bar image, PITCH: LED pitch in % (measured on the video).
  var VP = {
    1: [[0, 8, '#BB1AFF', '#5EFF1A'], [9, 8, '#1A56FF', '#FFC31A'], [18, 8, '#1AA6FF', '#FF721A'], [27, 8, '#1AE3FF', '#FF351A'], [36, 8, '#1AFFAC', '#FF1A6D'], [45, 8, '#73FF1A', '#A61AFF'], [54, 8, '#FF461A', '#1AD3FF'], [63, 8, '#FF1A5B', '#1AFFBD']],
    2: [[0, 35, '#FF441A', '#1AD4FF'], [36, 36, '#FF451A', '#1AD4FF']],
    3: [[1, 17, '#DB1AFF', '#3DFF1A'], [19, 17, '#1AE8FF', '#FF301A'], [37, 17, '#1A37FF', '#FFE11A'], [55, 17, '#77FF1A', '#A21AFF']],
    4: [[2, 13, '#FF741A', '#1AA4FF'], [16, 13, '#1AFFA8', '#FF1A70'], [30, 13, '#FF1A5E', '#1AFFBB'], [44, 13, '#1AFFA5', '#FF1A73'], [58, 13, '#1AB6FF', '#FF621A']],
    5: [[1, 13, '#1AE6FF', '#FF331A'], [15, 13, '#1AE0FF', '#FF391A'], [29, 13, '#1AE4FF', '#FF351A'], [43, 13, '#1AE4FF', '#FF351A'], [57, 13, '#1AE1FF', '#FF371A']],
    6: [[1, 23, '#1AE4FF', '#FF351A'], [25, 23, '#FF1A5D', '#1AFFBB'], [49, 23, '#1AE2FF', '#FF361A']],
    7: [[1, 5, '#FFBC1A', '#1A5DFF'], [7, 5, '#FFC01A', '#1A59FF'], [13, 5, '#FFAD1A', '#1A6BFF'], [19, 5, '#FFA71A', '#1A72FF'], [25, 5, '#FFA01A', '#1A79FF'], [31, 5, '#FFA61A', '#1A73FF'], [37, 5, '#FFAE1A', '#1A6BFF'], [43, 5, '#FFB21A', '#1A66FF'], [49, 5, '#FFB11A', '#1A67FF'], [55, 5, '#FFA91A', '#1A6FFF'], [61, 5, '#FFA31A', '#1A76FF'], [67, 5, '#FFA21A', '#1A76FF']],
    8: [[1, 19, '#1AFFFF', '#FF1A1A'], [21, 7, '#FF1A5E', '#1AFFBB'], [29, 7, '#C71AFF', '#51FF1A'], [37, 7, '#1ADDFF', '#FF3B1A'], [45, 19, '#1AFFBA', '#FF1A5E'], [65, 7, '#FFF31A', '#1A25FF']]
  };
  var VX = [5.090, 6.359, 7.609, 8.872, 10.136, 11.386, 12.649, 13.913, 15.163, 16.413, 17.677, 18.940, 20.204, 21.467, 22.731, 23.995, 25.258, 26.522, 27.785, 29.049, 30.312, 31.576, 32.840, 34.117, 35.380, 36.644, 37.908, 39.171, 40.448, 41.726, 42.989, 44.253, 45.530, 46.793, 48.057, 49.334, 50.611, 51.889, 53.166, 54.443, 55.707, 56.984, 58.261, 59.524, 60.802, 62.079, 63.356, 64.633, 65.910, 67.188, 68.465, 69.742, 71.019, 72.296, 73.573, 74.851, 76.128, 77.405, 78.682, 79.959, 81.236, 82.514, 83.791, 85.082, 86.372, 87.649, 88.927, 90.204, 91.495, 92.785, 94.062, 95.345];
  var PITCH = 1.271;
  var reduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  var phone = window.matchMedia ? window.matchMedia('(max-width: 640px)') : { matches: false };

  function parse(text) {
    var zones = [];
    String(text || '').split(/\r?\n/).forEach(function (line) {
      if (zones.length >= MAX || !line.trim()) return;
      var parts = line.split('|'), z = { label: parts[0].trim(), w: 0, c: '', pos: false };
      for (var i = 1; i < parts.length; i++) {
        var t = parts[i].trim();
        if (/^\d+(\.\d+)?$/.test(t)) z.w = parseFloat(t);
        else if (/^#([0-9a-f]{3}|[0-9a-f]{6})$/i.test(t)) z.c = t;
        else if (t.indexOf('~') > 0) z.range = t.split('~').map(function (s) { return s.trim(); });  // what a position zone controls, left to right
        else if (/^pos/i.test(t)) z.pos = true;
      }
      zones.push(z);
    });
    if (!zones.length) return zones;

    // Zones with a width keep it, the others share what is left; then whole LEDs that add up to 72.
    var given = 0, open = 0;
    zones.forEach(function (z) { if (z.w > 0) given += z.w; else open++; });
    var share = open ? (given < LEDS ? (LEDS - given) / open : given / (zones.length - open)) : 0;
    zones.forEach(function (z) { if (!(z.w > 0)) z.w = share; });
    var sum = zones.reduce(function (a, z) { return a + z.w; }, 0);
    var raw = zones.map(function (z) { return z.w * LEDS / sum; });
    var n = raw.map(function (r) { return Math.max(1, Math.floor(r)); });
    var left = LEDS - n.reduce(function (a, b) { return a + b; }, 0);
    var order = raw.map(function (r, i) { return i; }).sort(function (a, b) { return (raw[b] - Math.floor(raw[b])) - (raw[a] - Math.floor(raw[a])); });
    for (var k = 0; left > 0; k = (k + 1) % order.length, left--) n[order[k]]++;
    while (left < 0) {
      var big = n.indexOf(Math.max.apply(null, n));
      n[big]--; left++;
    }
    var s = 0;
    zones.forEach(function (z, i) { z.n = n[i]; z.s = s; s += n[i]; z.c = z.c || PAL[i % PAL.length]; });
    return zones;
  }

  // A layout on a filmed preset: zones, widths and colours from the preset, names and position zones from the lines.
  function fromPreset(d) {
    var names = parse(d.zones), p = String(d.preset || 1);
    var L = (VP[p] || VP[1]).map(function (g, i) {
      var t = names[i] || {};
      return { label: t.label || '', s: g[0], n: g[1], c: g[2], k: g[3], pos: !!t.pos, range: t.range };
    });
    L.preset = VP[p] ? p : '1';
    return L;
  }

  function init(root) {
    if (root.__zm) return;
    var json = root.querySelector('[data-zm-layouts]');
    if (!json) return;
    var data;
    try { data = JSON.parse(json.textContent); } catch (e) { return; }
    var vid = root.classList.contains('zonemap--video');  // zones on the real bar: LED strips filmed from the preset video
    var layouts = data.map(function (d) { return vid ? fromPreset(d) : parse(d.zones); });
    if (!layouts[0] || !layouts[0].length) return;
    root.__zm = true;

    var $ = function (sel) { return [].slice.call(root.querySelectorAll(sel)); };
    var segs = $('.zonemap__line > span'), labs = $('.zonemap__labels > span'), ticks = $('.zonemap__ticks > i');
    var tabs = $('[data-zm-tab]'), caps = $('.zonemap__cap');
    var labWrap = root.querySelector('.zonemap__labels'), draw = root.querySelector('.zonemap__draw');
    // phones: key under the numbers when the names don't fit under their zones (see phoneLabels)
    var key = document.createElement('div'), keyVals = [];
    key.className = 'zonemap__key';
    labWrap.appendChild(key);
    var anim = root.dataset.anim === 'true' && layouts.length > 1;
    var hitsOn = root.dataset.hits !== 'false';
    var tapOn = root.dataset.tap === 'true';
    var photo = root.classList.contains('zonemap--photo');  // zones on the real bar: ticks are the LEDs
    var hold = Math.max(2, parseFloat(root.dataset.hold) || 4) * 1000;
    var bar = root.querySelector('.zonemap__bar'), fx = root.querySelector('.zonemap__fx'), strips = {}, dots = [];
    var rangeBox = root.querySelector('.zonemap__ranges'), ranges = [];
    $('[data-zm-strip]').forEach(function (img) { strips[img.dataset.zmStrip] = img; });
    root.style.setProperty('--zm-hold', hold + 'ms');
    ticks.forEach(function (t, k) { t.style.setProperty('--i', k); });

    var cur = 0, auto = anim && !reduce.matches, visible = false, paused = false;
    var timer = 0, startedAt = 0, remaining = hold, hitTimer = 0, swapT = 0, sweepT = 0;

    function paintSegs(L) {
      segs.forEach(function (seg, i) {
        var z = L[i];
        seg.style.setProperty('--s', z ? z.s : LEDS);
        seg.style.setProperty('--n', z ? z.n : 0);
        if (z) seg.style.background = z.c;
        seg.classList.toggle('is-off', !z);
        seg.classList.toggle('is-pos', !!(z && z.pos));
        if (z && z.pos) seg.style.setProperty('--p', '50%');
      });
      L.forEach(function (z) { for (var p = z.s; p < z.s + z.n; p++) if (ticks[p]) ticks[p].style.setProperty('--c', z.c); });
      // like on the bar: the first LED of every zone after the first stays dark; a position zone shows its point (white LED)
      ticks.forEach(function (t) { t.classList.remove('is-gap', 'is-pos'); });
      L.forEach(function (z, zi) {
        if (zi > 0 && ticks[z.s]) ticks[z.s].classList.add('is-gap');
        if (z.pos && ticks[z.s + Math.floor(z.n / 2)]) ticks[z.s + Math.floor(z.n / 2)].classList.add('is-pos');
      });
    }
    // filmed preset: its strip replaces the last one; a position zone gets its dot (the hit LED) on the middle LED
    function paintStrip(L, animate) {
      var on = strips[L.preset];
      Object.keys(strips).forEach(function (k) {
        var img = strips[k], was = img.classList.contains('is-on');
        img.classList.toggle('is-under', !!animate && was && img !== on);
        img.classList.toggle('is-on', img === on);
      });
      if (on && on.loading === 'lazy') on.loading = 'eager';
      dots.concat(ranges).forEach(function (d) { if (d) d.remove(); });
      dots = []; ranges = [];
      L.forEach(function (z, zi) {
        if (!z.pos || !fx) return;
        var d = document.createElement('i');
        d.className = 'zonemap__dot';
        d.style.setProperty('--k', z.k);
        fx.appendChild(d);
        dots[zi] = d;
        // above the zone: what its position controls, from its left end to its right end
        if (z.range && rangeBox) {
          var r = document.createElement('span'), a = VX[z.s] - PITCH / 2, b = VX[z.s + z.n - 1] + PITCH / 2;
          r.className = 'zonemap__range';
          r.style.left = a.toFixed(3) + '%';
          r.style.width = (b - a).toFixed(3) + '%';
          [z.range[0], z.range[1] || ''].forEach(function (s) { var e = document.createElement('span'); e.textContent = s; r.appendChild(e); });
          r.appendChild(document.createElement('b'));
          r.appendChild(document.createElement('i'));
          rangeBox.appendChild(r);
          ranges[zi] = r;
        }
        placeDot(zi, z.s + Math.floor(z.n / 2));
      });
    }
    function placeDot(zi, led) {
      var z = layouts[cur][zi];
      if (dots[zi]) dots[zi].style.left = VX[led].toFixed(3) + '%';
      if (ranges[zi] && z) {
        var a = VX[z.s] - PITCH / 2, b = VX[z.s + z.n - 1] + PITCH / 2;
        ranges[zi].style.setProperty('--v', ((VX[led] - a) / (b - a) * 100).toFixed(2) + '%');
      }
    }
    // a hit lights the whole zone: its LEDs brighter (a lit copy of the strip, only over the zone) and their glow
    function glow(z) {
      if (!fx) return;
      var g = document.createElement('i'), a = VX[z.s] - PITCH / 2, b = VX[z.s + z.n - 1] + PITCH / 2;
      var on = strips[layouts[cur].preset], box = on && on.parentNode;
      if (on && box && on.animate) {
        var f = on.cloneNode(false), l = (a - 0.652) / 98.967 * 100, r = 100 - (b - 0.652) / 98.967 * 100;
        f.removeAttribute('data-zm-strip');
        f.className = 'zonemap__flash';
        f.style.clipPath = 'inset(0 ' + r.toFixed(2) + '% 0 ' + l.toFixed(2) + '%)';
        box.appendChild(f);
        f.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 640, easing: 'ease-out' }).onfinish = function () { f.remove(); };
      }
      g.className = 'zonemap__glow';
      g.style.left = a.toFixed(3) + '%';
      g.style.width = (b - a).toFixed(3) + '%';
      g.style.setProperty('--c', z.c);
      fx.insertBefore(g, fx.firstChild);  // under the dots
      if (!g.animate) { g.remove(); return; }
      g.animate([{ opacity: 0.95 }, { opacity: 0 }], { duration: 640, easing: 'ease-out' }).onfinish = function () { g.remove(); };
    }
    function fillLabels(L) {
      labs.forEach(function (lab, i) {
        var z = L[i], b = lab.querySelector('b'), v = lab.querySelector('i');
        if (z) {
          lab.style.setProperty('--s', z.s); lab.style.setProperty('--gs', z.s + 1);
          lab.style.setProperty('--n', z.n); lab.style.setProperty('--c', z.c);
        }
        if (b) b.textContent = z ? z.label : '';
        if (v) v.textContent = z && z.pos && !vid ? 'cc 64' : '';  // filmed bar: the range above the zone shows the value
        lab.classList.toggle('is-off', !z);
      });
      phoneLabels(L);
    }
    // Phones: each label sits under its own zone, as on desktop. When several names would wrap or run into each
    // other there, the row keeps only the numbers under the zones and a key below lists the names (.is-key).
    // In the single row the last label may reach left into free room and end at the bar's end (.is-end),
    // so a short name at the edge stays on one line.
    function phoneLabels(L) {
      var last = labs[L.length - 1];
      labs.forEach(function (lab) { lab.classList.remove('is-end'); lab.style.removeProperty('--span'); lab.style.removeProperty('--gs-end'); });
      labWrap.classList.remove('is-key', 'is-stagger');  // names visible again before they are measured
      labs.forEach(function (lab) { lab.classList.remove('is-low', 'is-rt', 'is-lt'); });
      if (vid && phone.matches && L.length > 1 && videoLabels(L)) { key.textContent = ''; keyVals = []; return; }
      var keyOn = false, end = null;
      if (phone.matches && L.length > 1) {
        var col = labWrap.clientWidth / LEDS, gap = parseFloat(getComputedStyle(root).getPropertyValue('--zg')) || 4, air = 8;
        // every name on one line, whatever box it sits in now
        var w = L.map(function (z, i) { var l = labs[i]; if (l) { l.style.width = 'max-content'; l.style.whiteSpace = 'nowrap'; } return l; })
          .map(function (l) { return l ? l.getBoundingClientRect().width : 0; });
        L.forEach(function (z, i) { if (labs[i]) { labs[i].style.width = ''; labs[i].style.whiteSpace = ''; } });
        var k = L.length - 1;
        // room for the last label when it ends at the bar's end: back to the text of the label before it
        var endFits = function () {
          var z = L[k], p = L[k - 1], need = w[k] - (z.n * col - gap);
          if (need <= 0 || w[k] > 96) return false;  // only short names; a long one wraps inside its zone instead
          return need <= z.s * col - (p.s * col + w[k - 1]) - air && need <= p.n * col;
        };
        // a name that is wider than its zone, or leaves less than `air` before the next label, doesn't fit
        var tight = 0;
        L.forEach(function (z, i) { if (w[i] > z.n * col - air && !(i === k && endFits())) tight++; });
        keyOn = L.length > 2 && tight >= 2;
        if (!keyOn && endFits()) end = last;
      }
      labWrap.classList.toggle('is-key', keyOn);
      key.textContent = '';
      keyVals = [];
      if (keyOn) {
        key.style.setProperty('--rows', Math.ceil(L.length / 3));
        L.forEach(function (z, i) {
          var row = document.createElement('div'), n = document.createElement('em'), b = document.createElement('b'), v = document.createElement('i');
          n.textContent = (i < 9 ? '0' : '') + (i + 1);
          b.textContent = z.label;
          v.textContent = z.pos && !vid ? 'cc 64' : '';
          row.appendChild(n); row.appendChild(b); row.appendChild(v);
          key.appendChild(row);
          keyVals[i] = v;
        });
      }
      if (end) {
        var zp = L[L.length - 2];
        end.classList.add('is-end');
        end.style.setProperty('--gs-end', zp.s + 1);  // phone CSS only; desktop keeps reading --gs
        end.style.setProperty('--span', zp.n + L[L.length - 1].n);
      }
    }
    // Phones, filmed bar: only the names, each centred under its zone (no numbers), in one row; a name at either end
    // of the bar that would run past it starts or ends with its zone instead (.is-lt, .is-rt). If they don't fit,
    // every second name sits one line lower. Returns false when even that doesn't fit (then the key takes over).
    function videoLabels(L) {
      var W = labWrap.clientWidth, col = W / LEDS, air = 8;
      var w = L.map(function (z, i) {
        var l = labs[i], b = l && l.querySelector('b'), v = l && l.querySelector('i');
        return (b ? b.getBoundingClientRect().width : 0) + (v && v.textContent ? v.getBoundingClientRect().width + 6 : 0);
      });
      var lo = [], hi = [];
      L.forEach(function (z, i) {
        var c = (z.s + z.n / 2) * col, a = c - w[i] / 2, b = c + w[i] / 2;
        if (a < 0) { a = z.s * col; b = a + w[i]; if (labs[i]) labs[i].classList.add('is-lt'); }
        else if (b > W) { b = (z.s + z.n) * col; a = b - w[i]; if (labs[i]) labs[i].classList.add('is-rt'); }
        lo[i] = a; hi[i] = b;
      });
      var clear = function (k) { return L.every(function (z, i) { return i + k >= L.length || hi[i] + air <= lo[i + k]; }); };
      if (clear(1)) return true;
      if (clear(2)) {
        labs.forEach(function (lab, i) { if (i % 2 && i < L.length) lab.classList.add('is-low'); });
        labWrap.classList.add('is-stagger');
        return true;
      }
      labs.forEach(function (lab) { lab.classList.remove('is-low', 'is-rt', 'is-lt'); });
      return false;
    }
    function describe(i) {
      var legend = (data[i] && data[i].legend) || '';
      draw.setAttribute('aria-label', (legend ? legend + ': ' : '') + layouts[i].map(function (z) { return z.label; }).join(', '));
    }
    // Same height for every layout, so the page below never moves while the map cycles.
    function measure() {
      if (!anim) { fillLabels(layouts[cur]); return; }
      labWrap.style.minHeight = '';
      root.classList.add('is-instant');
      var max = 0;
      layouts.forEach(function (L) { if (L.length) { fillLabels(L); max = Math.max(max, labWrap.offsetHeight); } });
      fillLabels(layouts[cur]);
      root.classList.remove('is-instant');
      labWrap.style.minHeight = max + 'px';
    }

    function sweep() {
      clearTimeout(sweepT);
      root.classList.remove('is-redraw');
      void root.offsetWidth;
      root.classList.add('is-redraw');
      sweepT = setTimeout(function () {
        root.classList.remove('is-redraw');
        $('.zonemap__strips .is-under').forEach(function (img) { img.classList.remove('is-under'); });
      }, LEDS * 6 + 460);
    }
    function show(i, animate) {
      var L = layouts[i];
      if (!L || !L.length) return;
      cur = i;
      stopHits();
      tabs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); t.setAttribute('aria-pressed', k === i ? 'true' : 'false'); });
      caps.forEach(function (c, k) { c.classList.toggle('is-active', k === i); });
      root.classList.toggle('has-pos', L.some(function (z) { return z.pos; }));
      describe(i);
      clearTimeout(swapT);
      if (!animate || reduce.matches) {
        root.classList.add('is-instant');
        labWrap.classList.remove('is-swap');
        paintSegs(L); fillLabels(L);
        if (vid) paintStrip(L, false);
        void root.offsetWidth;
        root.classList.remove('is-instant');
        return;
      }
      paintSegs(L);
      if (vid) paintStrip(L, false);  // the bar switches presets at once, no effect
      sweep();
      labWrap.classList.add('is-swap');
      // labels leave at once and come back, left to right, as the zones settle
      swapT = setTimeout(function () {
        fillLabels(L);
        swapT = setTimeout(function () { labWrap.classList.remove('is-swap'); }, 420);
      }, 200);
    }

    /* ---- simulated playing: the struck zone jumps (higher = harder), its LED flashes ---- */
    function hit() {
      if (!root.isConnected) return stopHits();
      var L = layouts[cur], zi = Math.floor(Math.random() * L.length), z = L[zi];
      if (!z) return;
      hitAt(zi, z.s + Math.floor(Math.random() * z.n), 0.35 + Math.random() * 0.65);
    }
    function hitAt(zi, led, v) {
      var z = layouts[cur][zi], seg = segs[zi];
      if (!z || !seg) return;
      if (seg.animate) {
        seg.animate([{ transform: 'scaleY(1)' }, { transform: 'scaleY(' + (1 + 0.4 * v).toFixed(3) + ')', offset: 0.15 }, { transform: 'scaleY(1)' }],
          { duration: 420, easing: 'cubic-bezier(0.2, 0.7, 0.3, 1)' });
      }
      var t = ticks[led];
      if (vid) {
        glow(z);
        if (z.pos) placeDot(zi, led);
      } else if (photo) {
        if (z.pos) { for (var q = z.s; q < z.s + z.n; q++) if (ticks[q]) ticks[q].classList.remove('is-pos'); if (t) t.classList.add('is-pos'); }
        if (t && t.animate && !t.classList.contains('is-gap')) t.animate([{ filter: 'brightness(2.2)' }, { filter: 'brightness(1)' }], { duration: 520, easing: 'ease-out' });
      } else if (t && t.animate) {
        var ink = getComputedStyle(t).backgroundColor;
        t.animate([{ opacity: 1, backgroundColor: z.c, transform: 'scaleY(1.8)' }, { opacity: 0.3, backgroundColor: ink, transform: 'scaleY(1)' }],
          { duration: 650, easing: 'ease-out' });
      }
      if (z.pos) {
        seg.style.setProperty('--p', ((led - z.s + 0.5) / z.n * 100).toFixed(2) + '%');
        var val = !vid && labs[zi] && labs[zi].querySelector('i'), cc = 'cc ' + Math.round((led - z.s) / Math.max(1, z.n - 1) * 127);
        if (val) val.textContent = cc;
        if (keyVals[zi] && !vid) keyVals[zi].textContent = cc;
      }
    }
    function startHits(delay, count) {
      stopHits();
      if (!hitsOn || reduce.matches) return;
      var left = count || Infinity;
      (function loop(ms) {
        hitTimer = setTimeout(function () {
          hit();
          var R = vid ? CALM : RHYTHM;
          if (--left > 0 && hitTimer) loop(R[Math.floor(Math.random() * R.length)]);
          else hitTimer = 0;
        }, ms);
      })(delay);
    }
    function stopHits() { clearTimeout(hitTimer); hitTimer = 0; }

    /* ---- auto cycle: runs only while visible, pauses on hover/focus, stops for good once a tab is picked ---- */
    function running() { return auto && visible && !paused && !document.hidden; }
    function restartProgress() {
      root.classList.remove('is-playing');
      void root.offsetWidth;
      root.classList.add('is-playing');
    }
    function next() {
      timer = 0;
      if (!root.isConnected) return;
      show((cur + 1) % layouts.length, true);
      remaining = hold;
      restartProgress();
      if (running()) { schedule(); startHits(MORPH + 150); }
    }
    function schedule() { clearTimeout(timer); startedAt = Date.now(); timer = setTimeout(next, remaining); }
    function update() {
      if (running()) {
        root.classList.add('is-playing');
        root.classList.remove('is-paused');
        if (!timer) { schedule(); startHits(300); }
      } else {
        if (timer) { clearTimeout(timer); timer = 0; remaining = Math.max(400, remaining - (Date.now() - startedAt)); }
        stopHits();
        if (auto) root.classList.add('is-paused');
      }
    }
    function pick(i, burst) {
      auto = false;
      clearTimeout(timer); timer = 0;
      root.classList.remove('is-playing', 'is-paused');
      root.classList.add('is-manual');
      show(i, true);
      if (burst) startHits(MORPH + 100, 6);
    }

    show(0, false);
    measure();
    var rt = 0;
    window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(measure, 200); });
    // crossing 640 px re-lays the labels at once, before paint, not 200 ms later
    if (phone.addEventListener) phone.addEventListener('change', measure); else if (phone.addListener) phone.addListener(measure);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);

    if (anim) {
      tabs.forEach(function (t, i) { t.addEventListener('click', function () { pick(i, true); }); });
      root.addEventListener('mouseenter', function () { paused = true; update(); });
      root.addEventListener('mouseleave', function () { paused = false; update(); });
      root.addEventListener('focusin', function () { paused = true; update(); });
      root.addEventListener('focusout', function (e) { if (!root.contains(e.relatedTarget)) { paused = false; update(); } });
      document.addEventListener('visibilitychange', update);
      if (reduce.addEventListener) reduce.addEventListener('change', function () { if (reduce.matches) { auto = false; update(); root.classList.remove('is-playing', 'is-paused'); } });
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        visible = entries[0].isIntersecting;
        // a picked tab holds while you look at it; scrolled away and back, the map plays again
        if (anim && !visible && !auto && !reduce.matches) { auto = true; remaining = hold; root.classList.remove('is-manual'); }
        if (anim) update();
        else if (visible && hitsOn && !reduce.matches) startHits(400, 8);
        else stopHits();
      }, { threshold: 0.35 }).observe(root);
    }

    /* ---- tap or click the bar: the zone under the finger is hit; a position zone shows where, as cc 0 to 127.
       Arrow keys move along the bar and hit there. The map holds the layout while someone plays it. ---- */
    if (tapOn) {
      var kbLed = -1;
      var holdLayout = function () {
        if (!anim) return;
        auto = false;
        clearTimeout(timer); timer = 0;
        root.classList.remove('is-playing', 'is-paused');
        root.classList.add('is-manual');
      };
      var playAt = function (led) {
        led = Math.max(0, Math.min(LEDS - 1, led));
        // the zone under the finger; on a dark LED between zones (filmed presets) the nearest one
        var L = layouts[cur], hz = -1, hd = Infinity;
        for (var zi = 0; zi < L.length; zi++) {
          var z = L[zi], d = led < z.s ? z.s - led : led >= z.s + z.n ? led - (z.s + z.n - 1) : 0;
          if (d < hd) { hd = d; hz = zi; }
        }
        if (hz < 0) return;
        led = Math.max(L[hz].s, Math.min(L[hz].s + L[hz].n - 1, led));
        stopHits(); holdLayout(); hitAt(hz, led, 0.8); kbLed = led;
      };
      draw.addEventListener('pointerdown', function (e) {
        if (e.button !== undefined && e.button !== 0) return;
        if (vid && bar) {  // nearest filmed LED
          var rb = bar.getBoundingClientRect(), xp = (e.clientX - rb.left) / rb.width * 100, nb = 0;
          if (!rb.width) return;
          VX.forEach(function (v, k) { if (Math.abs(v - xp) < Math.abs(VX[nb] - xp)) nb = k; });
          playAt(nb);
          return;
        }
        if (photo) {  // nearest LED on the photo (the pitch is not even)
          var best = -1, bd = Infinity;
          ticks.forEach(function (tk, k) { var b = tk.getBoundingClientRect(), dd = Math.abs(b.left + b.width / 2 - e.clientX); if (dd < bd) { bd = dd; best = k; } });
          if (best >= 0) playAt(best);
          return;
        }
        var line = root.querySelector('.zonemap__line') || draw, r = line.getBoundingClientRect();
        if (!r.width) return;
        playAt(Math.floor((e.clientX - r.left) / r.width * LEDS));
      });
      draw.addEventListener('keydown', function (e) {
        var step = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!step && e.key !== 'Enter' && e.key !== ' ') return;
        e.preventDefault();
        if (kbLed < 0) {
          var P = layouts[cur].filter(function (z) { return z.pos; })[0];
          kbLed = P ? P.s + Math.floor(P.n / 2) : LEDS / 2;
        }
        playAt(kbLed + step * 2);
      });
    }

    root.__zmApi = {
      pick: function (i) { pick(i, false); },
      resume: function () { if (anim && !reduce.matches) { auto = true; root.classList.remove('is-manual'); remaining = hold; update(); } }
    };
  }

  function boot(scope) { [].forEach.call((scope || document).querySelectorAll('[data-zonemap]'), init); }

  // Theme editor: re-init a re-rendered section; selecting a Layout block shows that layout.
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var tab = e.target, root = tab.closest && tab.closest('[data-zonemap]');
    if (root && root.__zmApi && tab.dataset.zmTab) root.__zmApi.pick(parseInt(tab.dataset.zmTab, 10));
  });
  document.addEventListener('shopify:block:deselect', function (e) {
    var root = e.target.closest && e.target.closest('[data-zonemap]');
    if (root && root.__zmApi) root.__zmApi.resume();
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
})();
